module.exports = __webpack_public_path__ + "static/media/foto-trabalhe-conosco.ff81045f.jpg";